module.exports = __webpack_public_path__ + "static/bird-d83028db5c02805bdbaeca0772db6b37.mp3";